import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import { useForm, FormField } from "ui/forms/Transaction/RefundAmount";
import { TriggerableDialog } from "ui/molecules/Dialog";
import { getCurrencySymbol } from "consts/general";

type Props = ReturnType<typeof useForm> & {
    readonly currency: string;
    readonly onCancel: () => void;
};

const SubmitRefund = ({
    isSubmitting,
    isValid,
    values,
    submitForm,
    currency,
    onCancel
}: Props) => (
    <Box
        sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',
            mt: 2
        }}
    >
        <Button
            variant="contained"
            color="error"
            onClick={onCancel}
        >
            Cancel
        </Button>
        <TriggerableDialog
            TriggerComponent={({ onClick }) => (
                <LoadingButton
                    variant='contained'
                    color='secondary'
                    disabled={!isValid}
                    loading={isSubmitting}
                    onClick={onClick}
                >
                    Proceed
                </LoadingButton>
            )}
            DialogActionsComponent={({ onClose }) => (
                <>
                    <Button
                        onPointerDown={onClose}
                        variant="contained"
                        color="error"
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant='contained'
                        color='secondary'
                        loading={isSubmitting}
                        onPointerDown={() => {
                            onClose();
                            onCancel();
                            submitForm();
                        }}
                    >
                        Confirm
                    </LoadingButton>
                </>
            )}
            ModalProps={{
                DialogProps: {
                    sx: {
                        '& .MuiDialog-container .MuiPaper-root': {
                            width: '100%',
                            maxWidth: 445
                        }
                    }
                },
                titleSlot: 'Refund'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1
                }}
            >
                <Typography
                    color='primary'
                    sx={{
                        fontFamily: 'inherit',
                        fontSize: 24,
                        fontWeight: 600
                    }}
                    gutterBottom
                >
                    {values[FormField.Amount]}
                </Typography>
                <Typography
                    color='text.disabled'
                    sx={{
                        fontFamily: 'inherit',
                        fontSize: 24,
                        fontWeight: 600
                    }}
                    gutterBottom
                >
                    {getCurrencySymbol(currency)}
                </Typography>
            </Box>
        </TriggerableDialog>
    </Box>
);

export default memo(SubmitRefund);
